<div class="card">
    <div class="card-body">
        <surge-table [delegate]="this" name="component-type"></surge-table>

        <div *ngIf="saved || error">
            <hr />
            <surge-alert
                type="success"
                *ngIf="saved"
                messages="Everything was sent."
                (onDismiss)="saved = false"
            ></surge-alert>
            <surge-alert type="danger" *ngIf="error" [messages]="error" (onDismiss)="error = null"></surge-alert>
        </div>
        <hr />
        <surge-data-import
            [importTemplateEndpoint]="importTemplateUrl"
            [importTemplateFilename]="'Handbook_Component Type_Template.xlsx'"
            [additionalData]="{ prefix: 'Component Type' }"
            [url]="importUrl"
            (failed)="importFailed($event)"
            (done)="afterImport($event)"
            (start)="beforeImport()"
        >
            <div class="text-right">
                <button surgeButton (click)="addNewItem()">Add new item</button>

                <button surgeButton (click)="save()" [disabled]="!canSave()" [busy]="saving">Save</button>
            </div>
        </surge-data-import>
    </div>
</div>
